var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionMarkCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.85 3.7a8.15 8.15 0 1 0 0 16.3 8.15 8.15 0 0 0 0-16.3M2 11.85C2 6.41 6.41 2 11.85 2s9.85 4.41 9.85 9.85-4.41 9.85-9.85 9.85S2 17.29 2 11.85m9.85-4.15c-1.512 0-2.633.726-3.003 1.512a.85.85 0 1 1-1.538-.724C8.036 6.944 9.879 6 11.85 6c1.27 0 2.454.385 3.339 1.049S16.7 8.694 16.7 9.85c0 1.969-1.75 3.368-3.696 3.742a.46.46 0 0 0-.242.127c-.05.053-.062.097-.062.131a.85.85 0 1 1-1.7 0c0-1.053.841-1.766 1.684-1.928C14.195 11.632 15 10.68 15 9.85c0-.5-.269-1.02-.832-1.441-.563-.423-1.38-.709-2.318-.709M11 16.85c0-.47.38-.85.85-.85h.01a.85.85 0 0 1 0 1.7h-.01a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgQuestionMarkCircle;